































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    props: {
        isBottom: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { root }) {
        const {
            initData: { shareUserInfo, ABConfig },
            message: { localLang: lang },
        } = root.$store.state;

        return {
            lang,
            shareUserInfo,
            config: props.isBottom ? ABConfig.bottomBanner : ABConfig.topBanner,
        };
    },
});
